import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_CONTACT = "GET_LIST_CONTACT";
export const GET_DETAIL_CONTACT = "GET_DETAIL_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";
export const SAVE_CONTACT = "SAVE_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const SET_LIST_CONTACT = "SET_LIST_CONTACT";
export const SET_DETAIL_CONTACT = "SET_DETAIL_CONTACT";


const state = {
    contact: [],
    contactDetail: []
};

const getters = {
    contact(state) {
        return state.contact;
    },
    contactDetail(state) {
        return state.contactDetail;
    },


};

const actions = {
    [GET_LIST_CONTACT](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_CONTACT}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_CONTACT, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_CONTACT](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_CONTACT}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_CONTACT, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_CONTACT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_CONTACT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_CONTACT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_CONTACT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_CONTACT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_CONTACT}`,id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_CONTACT](state, data) {
        state.contact = data.data;
    },
    [SET_DETAIL_CONTACT](state, data) {
        state.contactDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};